
export function pimAccordion(): void {
    const items = document.querySelectorAll<HTMLLIElement>('.block-pimfielddata__item');

    items.forEach(item => {
        const button = item.querySelector<HTMLButtonElement>('button.block-pimfielddata__name');
        const content = item.querySelector<HTMLElement>('.block-pimfielddata__value');

        if (!button || !content) return;

        const isInitiallyExpanded = content.getAttribute('data-init-expanded') === 'true';

        button.setAttribute('aria-expanded', isInitiallyExpanded.toString());

        if (!isInitiallyExpanded) {
            content.style.display = 'none';
            const icon = item.querySelector<HTMLSpanElement>('button i');
            if (icon) {
                icon.style.transform = 'rotate(90deg)';
            }
        }

        button.addEventListener('click', () => {
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            const newState = !isExpanded;

            button.setAttribute('aria-expanded', newState.toString());
            content.style.display = newState ? 'block' : 'none';
            const icon = item.querySelector<HTMLSpanElement>('button i');
            if (icon) {
                icon.style.transform = newState ? 'rotate(-90deg)' : 'rotate(90deg)';
            }
        });
    });
}